export default "__VITE_ASSET__CMqISE2j__"